module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAOCAMAAAAVBLyFAAAAWlBMVEVMaXGFhZB/g5WAg5N+g5OGhoZ/hZJ+g5N+g5R/hJN/hJOEhJd/hJOAgpR/hJN/g5J/hJR9gZOHh5aJiZyCgpJ/gpKAgpSAhJN/g5R/gZJ+hJOAhJOBhJOAhJQJLS/cAAAAHXRSTlMAFzpeqQQp+vPYoBuQy33k3kcRDS+wc4XsasW3URpGy6kAAACgSURBVHjaTc43DgNBDENRTtSkzdk2739Na7GA4Veo+GyEP3NmPhbgEWLQu7om2TyhTxx1nryzUqBipopLXN3gfIJuiUo6PVdfdgJW+FMmu2eYgUzNLqG6jn3FXNHIru4D8wdho1wAEs+515wYYUkJd/LI77UkOnye5JmDL5cwGf2eGwAz0kcv7Ow0kkOFMp7ybq1o4GbwiMfrJM/XseL2BfKcDHhyD/OxAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/icon-weibo.png
// module id = xF3L
// module chunks = 0